import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SendMoneyService } from '../send-money.service';
import { CommonService } from 'src/app/services/common.service';

declare var webengage
@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html',
  styleUrls: ['./step4.component.scss']
})
export class Step4Component implements OnInit {
  debitAuthorization = ""
  displayDebitAuthorization = false
  limit_error

  constructor(public sendMoneyService: SendMoneyService, public router: Router, public auth: AuthService,
    public common: CommonService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    //console.log(this.sendMoneyService.receiver)
    //console.log(this.sendMoneyService.purpose)
    //console.log(this.sendMoneyService.transactionDetails)

    let tempVal = this.activatedRoute.snapshot.queryParamMap.get('mydata');
    console.log("Happy tempVal");
    console.log(this.sendMoneyService.transactionDetails);
    console.log(this.sendMoneyService.transactionDetails.celoData);

    if (!(this.sendMoneyService.purpose && this.sendMoneyService.receiver)) {
      this.router.navigateByUrl("/send-money/step1")
    }
    else {
      webengage.track("send_money_details", {
        "Money Sent": this.sendMoneyService.transactionDetails?.sending_amt,
        "Money Received": this.sendMoneyService.transactionDetails?.send_amt,
        "Payment method": this.sendMoneyService.selectedCAPaymentMethod?.description,
        "sent currency": this.auth.user?.currency,
        "recieved currency": this.sendMoneyService.receiver?.currency,
      })
      this.sendMoneyService.isMarkConfirm = true
    }
    if (this.auth.user.country_id == 233) {
      this.getDebitAuthorization()
    }
  }
  onConfirmSendMoney() {
    console.log("onConfirmSendMoney called");
    this.displayDebitAuthorization = false
    this.common.showLoader()
    console.log("onConfirmSendMoney called2");
    this.sendMoneyService.sendModeny();
    this.sendMoneyService
    .transaction_error
    .subscribe(
      (error) => {

        this.limit_error = error;

      console.log("Princy mam happy ", error);
    })
  
    this.sendMoneyService.confirmScreen = true
  }

  goBack() {
    this.router.navigateByUrl("/send-money/step3")
    this.sendMoneyService.isMarkConfirm = false
  }

  getDebitAuthorization() {

    this.sendMoneyService.getDebitAuthorization().subscribe((res: any) => {
      this.common.showLoader()
      //console.log(res.data.debit_authorization)
      this.debitAuthorization = res.data.debit_authorization
      this.common.stopLoader()
    }, err => {
      alert("Debit Authorization api failed")
      this.common.stopLoader()
    })
  }
  changeHeight() {
    if (this.auth.user.country_id == 233) {
      (document.getElementsByClassName("div-block-15")[0].classList.contains('more-height'))
        ? document.getElementsByClassName("div-block-15")[0].classList.remove('more-height')
        : document.getElementsByClassName("div-block-15")[0].classList.add('more-height')
    }
    else {
      (document.getElementsByClassName("div-block-15-ca")[0].classList.contains('more-height-ca'))
        ? document.getElementsByClassName("div-block-15-ca")[0].classList.remove('more-height-ca')
        : document.getElementsByClassName("div-block-15-ca")[0].classList.add('more-height-ca')
    }
  }
}
